import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import './_educationManagementStudents.scss';

class EditDetailsModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dataClear: 0,
        }
    }

    render() {

        console.log("ddddddddddddddd", this.props.stateData.isSubmitting);
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Details</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    {this.props.stateData.currentStep == 5 ? (
                        <Form.Text className="form-text text-danger">
                            Updated successfully
                        </Form.Text>
                    ) : (
                        <Form.Text className="form-text text-danger">
                            {this.props.stateData.submitError}
                        </Form.Text>
                    )}
                    <Form>
                        <Form.Row>
                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="selectParentName">
                                <Form.Label className="h6">Parent Name </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="parent_name"
                                    placeholder="Parent name"
                                    value={this.props.stateData.parentName}
                                    onChange={this.props.parentHandleInputChange}
                                />
                                <Form.Text className="form-text text-danger">
                                    {this.props.stateData.parentNameError}
                                </Form.Text>
                            </Form.Group>
                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="selectParentName">
                                <Form.Label className="h6">Parent Mobile </Form.Label>
                                <Form.Control
                                    type="number"
                                    name="parent_mobile"
                                    placeholder="Parent Mobile"
                                    value={this.props.stateData.parentMobile}
                                    onChange={this.props.parentHandleInputChange}

                                />
                                <Form.Text className="form-text text-danger">
                                    {this.props.stateData.parentMobileError}
                                </Form.Text>
                            </Form.Group>
                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="selectParentName">
                                <Form.Label className="h6">Change Password </Form.Label>
                                <Form.Control
                                    type="text"
                                    name="parent_password"
                                    placeholder="Parent password"
                                    value={this.props.stateData.parentPassword}
                                    onChange={this.props.parentHandleInputChange}

                                />
                                <Form.Text className="form-text text-danger">
                                    {this.props.stateData.parentPasswordError}
                                </Form.Text>
                            </Form.Group>
                        </Form.Row>
                    </Form>
                </Modal.Body>
                <Card>

                </Card>
                <Modal.Footer variant="white">
                    <button className="addeEdit_btn" onClick={this.props.handleFormSubmit} disabled={this.props.stateData.isSubmitting} style={this.props.stateData.isSubmitting == true ? { cursor: "not-allowed" } : { cursor: "pointer" }}>
                        {
                            this.props.stateData.loadingSpinner == 1 ?
                                (<span className="spinner-border spinner-border-sm"></span>)
                                :
                                ("")
                        }SAVE</button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default (EditDetailsModal);